import React from "react";
import WineCart from "../components/WineCart";

export const PageCart = () => {
  return (
    <WineCart />
  );
}